import React, { useEffect } from "react";

// components
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";
import RightSideBar from "../../Container/RightSidebar";

// style
import HomeStyle from "./style";

//  images
import Sort from "../../Assets/sort.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import Pen from "../../Assets/pen.svg";
import { useState } from "react";

// -- redux
import { connect } from "react-redux";
import {
  GetAnnouncement,
  DeleteAnnouncement,
} from "../../Redux/Actions/AnnouncementAction";

function Announcement(props) {
  const [response, setResponse] = useState(false);
  const [Open, SetOpen] = useState(false);
  const [Data, SetData] = useState("");
  const [sortType, setSortType] = useState("asc");
  const [sortBy, setSortBy] = useState("description");
  const [tableEntries, setTableEntries] = useState([]);
  const [OpenModal, setModal] = useState(false);
  const [Name, setName] = useState(false);
  const [AnnouncementId, setAnnouncementId] = useState(false);

  useEffect(() => {
    if (props.search.length > 0) {
      const data = {
        sort_type: sortType,
        sort_by: sortBy,
        search_key: props.search,
      };
      props.GetAnnouncement(data);
    } else {
      const data = {
        sort_type: sortType,
        sort_by: sortBy,
        search_key: "",
      };
      props.GetAnnouncement(data);
    }
    SetOpen(false);
  }, [
    props.delete_data,
    props.edit_data,
    props.add_data,
    props.update_data,
    props.search,
    sortBy,
    sortType,
  ]);

  useEffect(() => {
    if (props.data) {
      setTableEntries(props.data.data);
    }
  }, [
    props.data,
    props.add_data,
    props.delete_data,
    props.edit_data,
  ]);

  const handleSort = (e, type) => {
    e.preventDefault();
    setSortBy(type);
    sortType === "asc" ? setSortType("desc") : setSortType("asc");
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    let data;
      setModal(!OpenModal);

    if (type === "delete_yes") {
      props.DeleteAnnouncement(AnnouncementId);
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  const deleteAnnouncement = (e, type, id) => {
    console.log("Called");
    e.preventDefault();
    setModal(type);
    setAnnouncementId(id);
  };

  const handleEdit = (e, data) => {
    e.preventDefault();
    SetData(data);
    SetOpen(true);
  };

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const handleModal = (e, type, name, id) => {
    e.preventDefault();
    setModal(type);
    setName(name);
    setAnnouncementId(id);
  };

  useEffect(() => {
    setTableEntries([]);
  }, [
    props.delete_data,
    props.edit_data,
    props.add_data,
    props.update_data,
    props.search,
    sortBy,
    sortType,
  ]);

  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-4">
        <div className="module-table-wrap table-responsive">
          <div className="table-wrap">
            <table className="table table-bordered m-0">
              <thead className="text-grey-6">
                <tr>
                  <th
                    scope="col"
                    className="dark-background cursor-pointer"
                    onClick={(e) => handleSort(e, "start_date")}
                  >
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Start Date</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="dark-background cursor-pointer"
                    onClick={(e) => handleSort(e, "end_date")}
                  >
                    <div className="d-flex justify-content-between">
                      <span className="f-16">End Date</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th scope="col" className="dark-background cursor-pointer"
                    onClick={(e) => handleSort(e, "description")}>
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Name</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <span className="f-16">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody className="light-grey-background text-white">
                {tableEntries.length > 0
                  ? tableEntries.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span className="f-16">{item.start_date}</span>
                          </td>
                          <td>
                            <span className="f-16">{item.end_date}</span>
                          </td>
                          <td>
                            <span className="f-16">{item.name}</span>
                          </td>
                          <td>
                            <div className="d-flex">
                              <img
                                src={Pen}
                                onClick={(e) => {
                                  handleEdit(e, item);
                                }}
                                alt="pen"
                                className="ml-2 mr-2 cursor-pointer"
                              />
                              <img
                                onClick={(e) =>
                                  deleteAnnouncement(e, "delete", item.id)
                                }
                                src={DeleteIcon}
                                alt="Delete"
                                className="ml-2 mr-3 cursor-pointer"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  : props.table_loading === false && (
                      <tr>
                        <td colSpan="9" className="text-center border-0">
                          <p className="m-0 text-white">Nothing found</p>
                        </td>
                      </tr>
                    )}
              </tbody>
            </table>

            <HomeStyle />
          </div>
        </div>

        <RightSideBar
          Type="Edit"
          data={Data}
          sidebar={Open}
          close={() => SetOpen(false)}
          response={(e) => e}
        />

        {OpenModal && (
          <Modal
            Name={Name}
            Type={OpenModal}
            Close={(e, type) => CloseModal(e, type)}
          />
        )}
      </div>
    </>
  );
}

const mapStateToProps = ({ GetAnnouncementReducer }) => {
  const {
    loading,
    table_loading,
    data,
    update_data,
    delete_data,
    edit_data,
    add_data,
  } = GetAnnouncementReducer;
  return {
    loading,
    table_loading,
    data,
    update_data,
    delete_data,
    edit_data,
    add_data,
  };
};

const mapDispatchToProps = {
  GetAnnouncement,
  DeleteAnnouncement,
};

export default connect(mapStateToProps, mapDispatchToProps)(Announcement);
